import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css';

/**
 * Standalone loading indicator with an optional caption.
 *
 * Accessibility (spec §12): the container is a polite live region, so the
 * caption is announced when it appears and when it changes — without moving
 * focus. When no caption is given the spinner still announces a generic
 * "Wird geladen…", because a purely visual busy state is invisible to a
 * screen reader.
 *
 * Props are unchanged: `size` ('small' | 'medium' | 'large') and `text`.
 */
export function LoadingSpinner({ size = 'medium', text = '' }) {
  const { t } = useTranslation();
  const sizeClass = `spinner-${size}`;

  return (
    <div className="loading-spinner-container" role="status" aria-live="polite">
      <div className={`loading-spinner ${sizeClass}`} aria-hidden="true">
        <div className="spinner-ring" />
      </div>
      {text ? (
        <span className="spinner-text">{text}</span>
      ) : (
        <span className="etch-visually-hidden">{t('states.loading')}</span>
      )}
    </div>
  );
}

export default LoadingSpinner;
